const states = [
  { type: 'ACT', title: 'states.ACT', intl: true },
  { type: 'NSW', title: 'states.NSW', intl: true },
  { type: 'NT', title: 'states.NT', intl: true },
  { type: 'QLD', title: 'states.QLD', intl: true },
  { type: 'SA', title: 'states.SA', intl: true },
  { type: 'TAS', title: 'states.TAS', intl: true },
  { type: 'VIC', title: 'states.VIC', intl: true },
  { type: 'WA', title: 'states.WA', intl: true },
];

export default states;
